import type { AvailabilitiesPlaceMapDTO } from '@/types/dto/agent';

export enum ElementType {
  PLACE = 'PLACE_TYPE',
  INTERNAL = 'INTERNAL_TYPE',
  SIGN = 'SIGN_TYPE',
}

export enum PlaceType {
  BERTH = 'PLACE_TYPE.BERTH',
  SEAT = 'PLACE_TYPE.SEAT',
  RECLINER = 'PLACE_TYPE.RECLINING_SEAT',
}

export type TypeIdTemplateLiteral = `${ElementType}.${string}`;

export type Coordinate = { x: number; y: number };

export type OrientationConfig = {
  degrees: number;
  elementOffset: Coordinate;
  priceStripOffset: Coordinate;
};

export type Floor = NonNullable<
  NonNullable<AvailabilitiesPlaceMapDTO['placeMaps']>[number]['floors']
>[number];

export type NestedOffset = {
  xOffset: number;
  yOffset: number;
};

export type PassengerInfo = {
  firstName?: string;
  lastName?: string;
  index: number;
};
